export class DeviceMeasurement {
    id: string;
    time: Date;
    deviceId: string;
    sensorId: string;
    validated: boolean;
    value: number;
    valueText: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;

    private spanishNames?: Record<string, string> = {
        id: "identificador",
        time: "tiempo",
        deviceId: "ID de dispositivo",
        sensorId: "ID de sensor",
        validated: "validado",
        value: "valor",
        valueText: "texto de valor",
        createdAt: "creado en",
        updatedAt: "actualizado en",
        createdBy: "creado por",
        updatedBy: "actualizado por",
    };

    constructor(data?: Partial<DeviceMeasurement>) {
        this.id = data?.id ?? "";
        this.time = data?.time ? new Date(data.time) : new Date();
        this.deviceId = data?.deviceId ?? "";
        this.sensorId = data?.sensorId ?? "";
        this.validated = data?.validated ?? false;
        this.value = data?.value ?? 0;
        this.valueText = data?.valueText ?? "";
        this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
        this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
        this.createdBy = data?.createdBy ?? "";
        this.updatedBy = data?.updatedBy ?? "";
    }

    getSpanishName(propertyName: string): string {
        if (this.spanishNames && this.spanishNames[propertyName]) {
            return this.spanishNames[propertyName];
        }
        return propertyName;
    }

    toPlainObject(): Record<string, any> {
        return {
            id: this.id,
            time: this.time,
            deviceId: this.deviceId,
            sensorId: this.sensorId,
            validated: this.validated,
            value: this.value,
            valueText: this.valueText,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            createdBy: this.createdBy,
            updatedBy: this.updatedBy,
        };
    }
}
